import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * AuthGuard - проверяет наличие токена и редиректит на login
 *
 * KISS: просто проверяет localStorage, без сложной логики
 */
export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    // Check for auth=required param (from magic link OAuth flow)
    const params = new URLSearchParams(window.location.search);
    const authRequired = params.get("auth");

    // Pass auth=required to login page to auto-start OAuth
    const loginPath =
      authRequired === "required" ? "/login?auth=required" : "/login";

    // Сохраняем куда хотели попасть для redirect после логина
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
